export default "__VITE_ASSET__b3556276__"